import { render, staticRenderFns } from "./BrandTop.vue?vue&type=template&id=1656c547&"
import script from "./BrandTop.vue?vue&type=script&lang=js&"
export * from "./BrandTop.vue?vue&type=script&lang=js&"
import style0 from "./BrandTop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports